import React from 'react';
import ProgressBar from '../Other/ProgressBar';

function WetFoodRemaining({ foodAmount, capacity }) {
  const completed = (foodAmount / capacity) * 100;
  const label = foodAmount + ' g';
  const bgcolor = '#23128c';
  return (
    <div
      className="flex flex-col w-11/12 mx-auto lg:w-full 
     bg-gray bg-opacity-50 border-2 border-transparent shadow-lg lg:shadow-md  p-2 rounded-xl lg:rounded-md"
    >
      <div class="flex lg:flex-row lg:items-center lg:justify-between flex-col items-start justify-evenly  ">
        <div style={{ flex: 1 }}>
          <span
            class="
           lg:text-sm
           text-xs
            font-semibold
            lg:tracking-wider
            uppercase
            inline-block
            py-1
            rounded-md
            text-white-bright           
            "
          >
            🧈 Wet Food remaining
          </span>
        </div>
        <div style={{ flex: 1, width: '100%' }}>
          <span class="lg:text-lg text-2xl whitespace-nowrap font-bold text-white-bright">
            <ProgressBar completed={completed} label={label} />
          </span>
        </div>
      </div>
    </div>
  );
}
export default WetFoodRemaining;
